import { Button, spacingFn } from '@britishcouncil/react-extro-ui';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export type ConfirmPaymentButtonSize = 'default' | 'big';

export const Root = styled(Button)<{ btnSize: ConfirmPaymentButtonSize }>`
  ${({ theme, btnSize }) => {
    if (btnSize === 'big') {
      return css`
        padding: ${theme.spacing.lg} ${spacingFn(5)};
      `;
    }
  }};
`;
